import { render, staticRenderFns } from "./Tiptap.vue?vue&type=template&id=61dd17b8"
import script from "./Tiptap.vue?vue&type=script&lang=js"
export * from "./Tiptap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports